export enum SocketClientState {
  ACTIVE,
  INACTIVE,
  CONNECTED,
  DISCONNECTED,
  ERROR
}
